import register from 'react-lib/dist/behavior-es';
import { filterSagas, filterReducer } from '../api/filtering';

export const [reducers, rootSaga] = register(
  { filter: filterReducer },
  [
    // add messages reducers here
  ],
  [...filterSagas]
);
